<div class="container">
  <div class="row push-top">
    <div class="col-xs-12 col-md-6 col-md-offset-3">
      <app-fire-content-block id="wfThankyouPageDetail"></app-fire-content-block>
    </div>
  </div>
</div>
